"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const CreateTeam_1 = __importDefault(require("./CreateTeam"));
const ManagePlan_1 = __importDefault(require("./ManagePlan"));
const Process_1 = __importDefault(require("./Process"));
const RoleSelect_1 = __importDefault(require("./RoleSelect"));
const SelectPlan_1 = __importDefault(require("./SelectPlan"));
const Subscription_1 = __importDefault(require("./Subscription"));
const plan_selection_1 = __importDefault(require("./plan-selection"));
const V1Team = () => {
    const match = (0, react_router_dom_1.useRouteMatch)();
    const { path } = match;
    React.useEffect(() => {
        // separate global styles from account profile routes
        document?.body?.setAttribute('id', 'v1-team');
    }, []);
    return (React.createElement(react_router_dom_1.Switch, null,
        React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/role` },
            React.createElement(RoleSelect_1.default, null)),
        React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/new` },
            React.createElement(CreateTeam_1.default, null)),
        React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/:teamId/plan` },
            React.createElement(SelectPlan_1.default, null)),
        React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/:teamId/plan/new` },
            React.createElement(plan_selection_1.default, null)),
        React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/:teamId/plan/process` },
            React.createElement(Process_1.default, null)),
        React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/:teamId/plan/manage` },
            React.createElement(ManagePlan_1.default, null)),
        React.createElement(react_router_dom_1.Route, { exact: true, path: `${path}/:teamId/subscription` },
            React.createElement(Subscription_1.default, null))));
};
exports.default = V1Team;
